import { Component } from '@angular/core';
import { isFormChange, onTypeChange } from 'app/core/shared/helper/equipment-registration.helper';
import { FormComponent } from 'app/modules/equipment-registration/component/form-component/form.component';
import { module } from 'app/modules/equipment-registration/equipment-registration.module';
import { Annulus } from 'app/modules/equipment-registration/model/annulus.model';
import { EquipRegistrationServices } from 'app/modules/equipment-registration/services/equipment-registration.service';

@Component({
  selector: 'app-annulus-c',
  templateUrl: './annulus-c.component.html',
  standalone: true,
  imports: [
    ...module,
    FormComponent
  ],
  styleUrls: ['./annulus-c.component.scss']
})
export class AnnulusCComponent {
  public equipmentRegistration$ = this.equipmentServices.equipmentRegistration$
  public annulusC: Annulus = new Annulus();
  public tempAnnulusC: Annulus = new Annulus();

  public isReplace: boolean = true;
  public disabledToggle: boolean = true;

  constructor(
    private equipmentServices: EquipRegistrationServices
  ) { }

  ngOnInit() {
    this.initializeAnnulusForm()

    this.equipmentRegistration$.subscribe(wellEquipment => {
      if (!wellEquipment) return '';

      if (wellEquipment?.annulusC) {
        this.annulusC = new Annulus(wellEquipment?.annulusC);
      } else {
        this.initializeAnnulusForm()
      }

      this.handleFormValue()
      this.annulusC.wellStringId = wellEquipment.wellStringId
      this.tempAnnulusC.wellStringId = wellEquipment.wellStringId
      this.isReplace = !wellEquipment?.annulusC;
      this.disabledToggle = !wellEquipment?.annulusC;
    })
  }

  private handleFormValue() {
    if (!this.annulusC.mdSceValveTypeId) {
      this.setSceValveTypeId()
    }

    this.tempAnnulusC = new Annulus(this.annulusC)
  }

  private initializeAnnulusForm(): void {
    this.annulusC.reset()
  }

  private setSceValveTypeId() {
    this.equipmentServices.getSceValveTypeId('SCV').subscribe(id => {
      this.annulusC.mdSceValveTypeId = this.tempAnnulusC.mdSceValveTypeId = id
    })
  }

  disabledSave(): boolean {
    return !this.annulusC.wellStringId && !this.annulusC.mdSceValveTypeId || isFormChange(this.annulusC, this.tempAnnulusC)
  }

  save() {
    onTypeChange(this.annulusC)

    const operation = this.isReplace ?
      this.equipmentServices.addSceWellhead(this.annulusC) :
      this.equipmentServices.updateSceWellhead(this.annulusC);

    operation.subscribe((res) => {
      if (res) {
        this.equipmentServices.getEquipmentRegistration(this.annulusC.wellStringId).subscribe();
      }
    });
  }
}
